"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import { GameControlsFullscreen } from "@workspace/frontend-ui";
import type { FC } from "react";

const FullscreenButton: FC = () => {
  const { toggleFullscreen, t } = useGamePageData();

  return (
    <GameControlsFullscreen
      data-testid="fullscreen-button"
      aria-label={t("game.controls.fullscreen.enter", "Enter fullscreen")}
      onClick={toggleFullscreen}
    />
  );
};

export default FullscreenButton;
